import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { organizationSchema, websiteSchema } from '../../seo/config';
import { getReviews } from '../../utils/content';

// Site-wide structured data (LegalService/Organization + WebSite).
// Loads the reviews so the Organization carries an AggregateRating
// (⭐ in search results) when real reviews exist.
const SiteSchema = () => {
    const [rating, setRating] = useState(null);

    useEffect(() => {
        getReviews().then((reviews) => {
            if (!reviews.length) return;
            const average = reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length;
            setRating({ ratingValue: Math.round(average * 10) / 10, reviewCount: reviews.length });
        });
    }, []);

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(organizationSchema({ aggregateRating: rating }))}
            </script>
            <script type="application/ld+json">
                {JSON.stringify(websiteSchema())}
            </script>
        </Helmet>
    );
};

export default SiteSchema;
